// import GMaps from '../libs/gmaps/gmaps.min.js'
import MarkerClusterer from '@google/markerclustererplus'
import '../../scss/components/groundsMap'

function numberFormat (number, decimals, decPoint, thousandsSep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
  const n = !isFinite(+number) ? 0 : +number
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  const dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s = ''
  const toFixedFix = function (n, prec) {
    const k = Math.pow(10, prec)
    return '' + Math.round(n * k) / k
  }
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  if (s[0].length > 3) { s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep) }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

const groundsMap = {

  $m: $('#map-grounds'),
  $f: $('form[name="ofForm"]'),

  buildMap () {
    const _this = this
    const markers = []
    let map
    let center

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: document.location.origin + '/terrains-constructibles/get',
      data: {
        search: _this.$f.find('input[name="search"]').val(),
        type: _this.$f.find('input[name="type"]').val(),
        slug: _this.$f.find('input[name="slug"]').val(),
        surface_from: _this.$f.find('input[name="surface_from"]').val(),
        surface_to: _this.$f.find('input[name="surface_to"]').val(),
        budget_from: _this.$f.find('input[name="budget_from"]').val(),
        budget_to: _this.$f.find('input[name="budget_to"]').val()
      },
      success: function (response) {
        let countGrounds = 0
        let countCities = 0
        let infowindow
        const boxList = []
        let title
        let latLng
        let marker
        const icon = document.location.origin + '/assets/img/icons/map-marker-offer-37x45.png'
        const iconCurrent = document.location.origin + '/assets/img/icons/map-marker-current-offer-37x45.png'
        const iconGrey = document.location.origin + '/assets/img/icons/map-marker-disable-offer-37x45.png'
        const mapStyle = [
          {
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              }
            ]
          },
          {
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#91aa1f'
              }
            ]
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#f5f5f5'
              }
            ]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#bdbdbd'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dadada'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#616161'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5'
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#c9c9c9'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e'
              }
            ]
          }
        ]

        // affiche les terrains de tous les départements
        if (response.type === 'all') {
          if (typeof (response.listing) !== 'undefined') {
            /* global google */
            center = new google.maps.LatLng(49.8923598, 2.2951041)
            map = new google.maps.Map(_this.$m[0], {
              zoomControl: true,
              maxZoom: 13,
              center: center,
              scrollwheel: false,
              streetViewControl: false,
              panControl: false,
              mapTypeControl: false,
              draggable: true,
              disableDoubleClickZoom: false,
              keyboardShortcuts: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP,
              styles: mapStyle
            })
          }

          $.each(response.listing, function (i, elem) {
            countGrounds += parseInt(elem.total)
            title = elem.total === 1 ? '1 terrain' : elem.total + ' terrains'
            latLng = new google.maps.LatLng(elem.lat, elem.lon)
            marker = new google.maps.Marker({
              id: i,
              position: latLng,
              icon: icon,
              title: elem.city + ' : ' + title,
              textColor: '#ffffff'
              // link: elem.link
            })
            // marker.setAnimation(google.maps.Animation.BOUNCE)

            // infobulle
            const boxText = document.createElement('div')
            boxText.id = i
            boxText.data = elem
            boxText.innerHTML = '<div class="text-center text-fixed" id="content"><span class="h6 text-uppercase">' + elem.city + '&nbsp;: <span class="text-danger">' + (elem.total === 0 ? 'aucun terrain' : (elem.total === 1 ? '1 terrain' : elem.total + ' terrains')) + '</span></span><br>' + elem.content + '<br><a class="btn btn-sm btn-primary mt-2" href="' + elem.link + '">Voir toutes les offres disponibles</a></div>'
            boxList.push(boxText)
            infowindow = new google.maps.InfoWindow({
              enableEventPropagation: true
            })

            markers.push(marker)
            // google.maps.event.addListener(marker, 'click', function () { document.location.href = '/terrains-a-batir/' + this.link })
            google.maps.event.addListener(marker, 'click', (function (marker) {
              return function () {
                infowindow.setContent(boxList[this.id])
                infowindow.open(map, marker)
              }
            })(marker, i))
            countCities++
          })

          const countCitiesS = countCities > 0 ? (countCities === 1 ? 'dans 1 commune' : 'dans ' + numberFormat(countCities, 0, '.', ' ') + ' communes') : ''
          const countGroundsS = countGrounds > 0 ? (countGrounds === 1 ? '1 terrain' : numberFormat(countGrounds, 0, '.', ' ') + ' terrains') : 'aucun terrain'
          if (countCities === 0 && countGrounds === 0) {
            $('.count').text('aucun terrain')
          } else {
            $('.count').text(countGroundsS + ' ' + countCitiesS)
          }

          // retire le message supplémentaire de terrains disponibles pour toute une zone ne correspondant pas aux filtres mais utiles
          if ($('#sup').length) {
            const totalByDep = parseInt($('#sup').attr('data-total'))
            if (totalByDep <= countGrounds) {
              $('#sup').hide()
            } else {
              $('#sup').show()
            }
          }
        }

        // affiche les terrains à proximité de la ville
        if (response.type === 'city') {
          let found = false
          center = new google.maps.LatLng(_this.$m.attr('map-lat'), _this.$m.attr('map-lng'))
          map = new google.maps.Map(_this.$m[0], {
            zoomControl: true,
            zoom: 12,
            maxZoom: 13,
            center: center,
            scrollwheel: false,
            streetViewControl: false,
            panControl: false,
            mapTypeControl: false,
            draggable: true,
            disableDoubleClickZoom: false,
            keyboardShortcuts: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: mapStyle
          })

          $.each(response.listing, function (i, elem) {
            countGrounds += parseInt(elem.total)
            title = elem.total === 1 ? '1 terrain' : elem.total + ' terrains'
            latLng = new google.maps.LatLng(elem.lat, elem.lon)
            // if (elem.link !== _this.$f.find('input[name="slug"]').val()) {
            marker = new google.maps.Marker({
              id: i,
              position: latLng,
              icon: elem.lookup === true ? iconCurrent : icon,
              title: elem.city + ' : ' + title,
              link: elem.link
            })
            if (elem.lookup === true) {
              found = true
              marker.setAnimation(google.maps.Animation.BOUNCE)
            }

            // infobulle
            const boxText = document.createElement('div')
            boxText.id = i
            boxText.data = elem
            boxText.innerHTML = '<div class="text-center text-fixed" id="content"><span class="h6 text-uppercase">' + elem.city + '&nbsp;: <span class="text-danger">' + (elem.total === 0 ? 'aucun terrain' : (elem.total === 1 ? '1 terrain' : elem.total + ' terrains')) + '</span></span><br>' + elem.content + '<br><a class="btn btn-sm btn-primary mt-2" href="' + elem.link + '">Voir toutes les offres disponibles</a></div>'
            boxList.push(boxText)
            infowindow = new google.maps.InfoWindow({
              enableEventPropagation: true
            })

            markers.push(marker)
            // google.maps.event.addListener(marker, 'click', function () { document.location.href = '/terrains-a-batir/' + this.link })
            google.maps.event.addListener(marker, 'click', (function (marker) {
              return function () {
                infowindow.setContent(boxList[this.id])
                infowindow.open(map, marker)
              }
            })(marker, i))
            // }
            countCities++

            if (elem.city === 'Ambrumesnil') {
              console.log(elem)
            }
          })

          // ajoute le marker de la ville recherchée si non trouvée dans le listing
          if (!found) {
            marker = new google.maps.Marker({
              position: center,
              icon: iconGrey,
              title: _this.$f.find('input[name="search"]').val(),
              // id: i,
              textColor: '#ffffff'
            })
            marker.setAnimation(google.maps.Animation.BOUNCE)
            markers.push(marker)
          }
        }

        const c = '#eee'
        const s = '20'
        const f = 'Poppins'
        const w = '400'
        const u = '/assets/img/icons/'
        const clusterStyles = [
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-52x51.png',
            height: 52,
            width: 51,
            anchorText: [1, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-56x55.png',
            height: 56,
            width: 55,
            anchorText: [3, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-65x64.png',
            height: 65,
            width: 64,
            anchorText: [6, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm-78x77.png',
            height: 78,
            width: 77,
            anchorText: [12, 0],
            fontWeight: w
          },
          {
            textColor: c,
            textSize: s,
            fontFamily: f,
            url: u + 'm90x89.png',
            height: 90,
            width: 89,
            anchorText: [15, 0],
            fontWeight: w
          }
        ]

        // dessine la carte ou affiche un message
        if (countGrounds > 0) {
          const mc = new MarkerClusterer(map, markers, {
            styles: clusterStyles
          })
          if (response.type === 'all') {
            mc.fitMapToMarkers()
            if (countCities === 1) { // si 1 seule ville, on dézoome pour éviter un zoom trop fort après le fit des clusters sur la map
              const listener = google.maps.event.addListener(map, 'idle', function () {
                if (map.getZoom() > 16) map.setZoom(12)
                google.maps.event.removeListener(listener)
              })
            }
          }
        } else {
          _this.$m.html('<div class="p-4" role="alert">' +
            '<p>' +
              '<b>Il n\'y a actuellement aucun terrain constructible disponible.</b> ' +
              'Nous vous invitons à modifier vos critères de recherche ou à vous inscrire à une alerte terrain du département de votre choix pour être tenu informé de ' +
              'l\'ajout de nouvelles offres correspondant à vos critères.' +
            '</p>' +
            '<a href="' + document.location.origin + '/terrains-constructibles/alertes-terrain" class="btn btn-primary">S\'inscrire à une alerte terrain</a>' +
          '</div>')
        }
      }
    })
  },

  //  resize: function () {
  //    if (this.$m.length) {
  //      if (!this.$m.hasClass('mobile')) { this.$m.height($('#sidebar').outerHeight(true) - 24) }
  //    }
  //  },

  init: function () {
    // this.resize()
    this.buildMap()
    // refresh waypoints au chargement d'une image
    //    $('.lazyload').on('lazyloaded', () => {
    //      this.resize()
    //    })
    //    $(window).on('resize', () => {
    //      this.resize()
    //    })
  }

}

groundsMap.init()
